const sectionAnchors = document.querySelectorAll('.section-anchor');

if (sectionAnchors.length > 0) {
  const sectionHeight = (section) => section.offsetHeight;

  const updateSectionHeights = () => {
    sectionAnchors.forEach((elem) => {
      const nextSection = elem.nextElementSibling;
      if (nextSection) {
        const nextSectionHeight = sectionHeight(nextSection);
        elem.style.setProperty('--section-height', `${nextSectionHeight}px`);
      }
    });
  };

  window.addEventListener('load', updateSectionHeights);
  window.addEventListener('resize', debounce(updateSectionHeights, 200));
}
